import NoPartnerSelected from '@playground/features/promo-codes/NoPartnerSelected'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/_partners/promo-codes/')({
  component: NoPartnerSelected,
})
